import { UserSkills } from '../components/interfaces/Interfaces';

export const skillIcons: { [key: number]: string } = {
  [UserSkills.FIREBALL]: 'fireball',
  [UserSkills.BALSAM]: 'balsam',
  [UserSkills.BLOODBOIL]: 'bloodboil',
  [UserSkills.SUNSET]: 'sunset',
  [UserSkills.MIST]: 'mist_hide',
  [UserSkills.GIANT_WATERFALL]: 'giant_waterfall',
  [UserSkills.CRYSTAL_BLADE]: 'crystal_blade',
  [UserSkills.PRAYER]: 'prayer',
  [UserSkills.GREAT_MUD_RIVER]: 'great_mud_river',
  [UserSkills.DETONATING_CLAY]: 'detonating_clay',
  [UserSkills.EARTH_PRISON]: 'earth_prison',
  [UserSkills.MUD_WALL]: 'mud_wall',
  [UserSkills.THUNDERFALL]: 'thunderfall',
  [UserSkills.CHIDORI]: 'chidori',
  [UserSkills.STATIC_FIELD]: 'static_field',
  [UserSkills.FLYING_THUNDER_GOD]: 'flying_thunder_god',
  [UserSkills.QUICKSTEP]: 'quickstep',
  [UserSkills.WINDSTORM_ARRAY]: 'windstorm_array',
  [UserSkills.GALE_PALM]: 'gale_palm',
  [UserSkills.RASENGAN]: 'rasengan',
  [UserSkills.LOTUS]: 'lotus',
  [UserSkills.GREAT_STRENGTH]: 'great_strength',
  [UserSkills.EIGHT_TRIGRAM_PALM]: 'eight_trigram_palm',
  [UserSkills.THE_EIGHT_INNER_GATES_RELEASED]: 'the_eight_inner_gates_released',
  [UserSkills.PUPPET]: 'puppet',
  [UserSkills.BOMB]: 'bomb',
  [UserSkills.LIQUOR]: 'liquor',
  [UserSkills.SNARED]: 'snared',
  [UserSkills.TAILED_BEAST_HEART]: 'tailed_beast_heart',
  [UserSkills.CURSED_SEAL_OF_HEAVEN]: 'cursed_seal_of_heaven',
  [UserSkills.FIVE_ELEMENTAL_SEAL]: 'five_elemental_seal',
  [UserSkills.ASSASSINATE]: 'assassinate',
  [UserSkills.SUBSTITUTE]: 'substitution_technique',
  [UserSkills.SEXY_TECHNIQUE]: 'sexy_technique',
  [UserSkills.DEATH_MIRAGE_JUTSU]: 'death_mirage_jutsu',
  [UserSkills.DEAD_DEMON_CONSUMING_SEAL]: 'dead_demon_consuming_seal',
  [UserSkills.MYSTICAL_PALM_TECHNIQUE]: 'mystical_palm_technique',
  [UserSkills.PRE_HEALING_JUTSU]: 'pre_healing_jutsu',
  [UserSkills.CHAKRA_BLADE]: 'chakra_blade',
  [UserSkills.CREATION_REBIRTH]: 'creation_rebirth',
};
